import { Slider } from '@miblanchard/react-native-slider';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { StyleSheet, View } from 'react-native';

import Text from '../Text';

export type RangeSliderInputFieldProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  minimumValue: number;
  maximumValue: number;
  title: string;
  subtitle?: string;
  step?: number;
  showError?: boolean;
  disabled?: boolean;
};

const RangeSliderInputField = <T extends FieldValues>({
  name,
  control,
  minimumValue,
  maximumValue,
  title,
  subtitle,
  step,
  showError = true,
  disabled = false
}: RangeSliderInputFieldProps<T>) => (
  <Controller
    disabled={disabled}
    name={name}
    control={control}
    render={({ field, fieldState: { error } }) => (
      <View>
        <View style={styles.groupLabeContainer}>
          <Text style={styles.title}>{title}</Text>

          {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}
        </View>

        <Slider
          disabled={disabled}
          minimumValue={minimumValue}
          maximumValue={maximumValue}
          value={field.value}
          step={step}
          onValueChange={(newValues) => field.onChange(newValues)}
          renderAboveThumbComponent={() => <Text style={styles.aboveThumbComponent}>{field.value}</Text>}
        />
        {showError && !!error?.message && <Text style={styles.errorText}>{error.message}</Text>}
      </View>
    )}
  />
);

export default RangeSliderInputField;

const styles = StyleSheet.create({
  optionContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },

  groupLabeContainer: {
    flexDirection: 'column',
    gap: 8,
    marginBottom: 18
  },

  title: {
    fontSize: 18,
    fontWeight: '700',
    color: 'black'
  },

  subtitle: {
    fontSize: 16,
    color: 'black'
  },

  aboveThumbComponent: {
    width: 30,
    textAlign: 'center',
    backgroundColor: 'black',
    color: 'white',
    borderRadius: 5,
    overflow: 'hidden',
    marginLeft: -14,
    marginBottom: -5
  },

  errorText: {
    marginTop: 10,
    fontSize: 12,
    color: 'red'
  }
});
